export const normalizeHomeTopicKey = (value: string | null): string | null => {
  const normalized = value
    ?.normalize('NFKD')
    .replace(/\p{Mark}+/gu, '')
    .toLocaleLowerCase('en-US')
    .replace(/['’]/gu, '')
    .replace(/[^\p{Letter}\p{Number}]+/gu, ' ')
    .trim()
    .replace(/\s+/g, ' ');
  return normalized && normalized.length <= 120 && normalized.split(' ').length <= 3 ? normalized : null;
};

export const formatHomeTopicLabel = (key: string): string => key
  .split(' ')
  .map((word) => word.charAt(0).toLocaleUpperCase('en-US') + word.slice(1))
  .join(' ');

export const buildHomeTopicSearch = (currentSearch: string, topicKey: string | null): string => {
  const params = new URLSearchParams(currentSearch);
  if (topicKey) params.set('topic', topicKey);
  else params.delete('topic');
  return params.toString() ? `?${params.toString()}` : '';
};
